export function portalBaseUrl(): string {
  const configured = import.meta.env.VITE_PORTAL_BASE_URL?.trim()
  if (configured) return configured.replace(/\/$/, '')
  if (import.meta.env.DEV) return 'http://portal.localhost:15176'
  return `${window.location.origin}/portal`
}

export function portalEntryUrl(path = '/'): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${portalBaseUrl()}${normalized}`
}
